export default {
  countries: {
    all: {
      url: "https://raw.githubusercontent.com/LlONED/geography-exams/master/db/countries/all.json",
      cacheKey: "countries",
    },
  },
  localization: {
    url: "https://raw.githubusercontent.com/LlONED/geography-exams/master/db/localization/",
    cacheKey: "localization",
    langs: ["ru", "en", "de", "fr", "es", "it"],
  },
};
